import { render, staticRenderFns } from "./CreateItemNote.vue?vue&type=template&id=bb13d82c&"
import script from "./CreateItemNote.vue?vue&type=script&lang=js&"
export * from "./CreateItemNote.vue?vue&type=script&lang=js&"
import style0 from "./CreateItemNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports